export interface IParsedBox {
  name: string;
  size: number;
  payload: ArrayBuffer;
}

export const findBoxesInArrayBuffer: (buffer: ArrayBuffer) => IParsedBox[] = (buffer) => {
  const dataViewOfBuffer: DataView = new DataView(buffer);
  let currentOffset: number = 0;
  const boxesCache: IParsedBox[] = [];
  while (currentOffset < buffer.byteLength) {
    const size: number = dataViewOfBuffer.getUint32(currentOffset, false);
    const box: IParsedBox = {
      size,
      name: new TextDecoder().decode(buffer.slice(currentOffset + 4, currentOffset + 8)),
      payload: buffer.slice(currentOffset + 8, currentOffset + size),
    };
    currentOffset += size;
    boxesCache.push(box);
  }

  return boxesCache;
};

export const combineArrayBuffers: (buffers: ArrayBuffer[]) => ArrayBuffer = (buffer) => {
  const totalSize: number = buffer.reduce((s, c) => s + c.byteLength, 0);
  const resultBuffer: Uint8Array = new Uint8Array(totalSize);

  buffer.reduce((offset, buffer) => {
    resultBuffer.set(new Uint8Array(buffer), offset);
    return offset + buffer.byteLength;
  }, 0);

  return resultBuffer.buffer as ArrayBuffer;
};
